import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";
import { Button, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import useBreakpoints from "../../useBreakpoints";
import Box from "../Box";
import { CircularIconContainer } from "../CircularIconContainer";

type Props = {
	onStart?: () => void;
};

export const LeaderboardJoinCta = ({ onStart }: Props) => {
	const theme = useAppTheme();
	const { t } = useTranslation();
	const { xsDown } = useBreakpoints();

	const isStacked = xsDown;

	const button = onStart ? (
		<Button mode="contained" icon="play-circle-outline" onPress={onStart}>
			{t("leaderboard.unranked.cta")}
		</Button>
	) : null;

	return (
		<Box gap={16}>
			<Box flexDirection="row" alignItems="center" gap={12}>
				<CircularIconContainer
					iconName="trending-up"
					variant="square"
					size={48}
					iconSize={24}
					backgroundColor={theme.colors.elevation.level1}
					iconColor={theme.colors.primary}
				/>
				<Box flex={1} gap={4}>
					<Text
						variant="titleMedium"
						style={[styles.title, { color: theme.colors.onSurface }]}
					>
						{t("leaderboard.unranked.title")}
					</Text>
					<Text
						variant="bodySmall"
						style={{ color: theme.colors.onSurfaceVariant }}
					>
						{t("leaderboard.unranked.description")}
					</Text>
				</Box>
				{!isStacked && button}
			</Box>
			{isStacked && button}
		</Box>
	);
};

const styles = StyleSheet.create({
	title: {
		fontWeight: "600",
	},
});
